import { render, staticRenderFns } from "./ProjectSummaryView.vue?vue&type=template&id=fc87d3fc&scoped=true"
import script from "./ProjectSummaryView.vue?vue&type=script&lang=ts"
export * from "./ProjectSummaryView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectSummaryView.vue?vue&type=style&index=0&id=fc87d3fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc87d3fc",
  null
  
)

export default component.exports